/*eslint-disable*/

import React, { useCallback, useState } from 'react';
import { App, Button, Col, Form, Input, InputNumber, Modal, Row, Tooltip } from 'antd';
import { NumericFormat } from 'react-number-format';
import { withValueCap } from 'pages/globals/global';
import { Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow } from '@mui/material';
import InputLabel from 'components/InputLabel/index';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import GrossRentExcelModal from '../LeaseUtils/Excel/GrossRentExcelModal';

import { constantFormValues } from '../../root';
import { debounce } from 'lodash';
import AdvanceAmountHistory from '../LeaseUtils/History/AdvanceAmountHistory';
import { processArrays } from '../LeaseUtils/helper';

/**
 * Enhanced GrossRent component that provides a dynamic table for users to add
 * and edit monthly gross rent values directly in the CardAccordion.
 *
 * Now with Excel import functionality for bulk data entry.
 *
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.form - Form instance from parent
 * @param {string} props.screen - Current screen mode ('CREATE', 'EDIT', or 'VIEW')
 * @param {string} props.formListName - Name of form list for the table data
 */
const AdvanceAmount = ({ form, screen = 'CREATE', formListName = 'advanceAmountList', advanceAmountListSet = [] }) => {
	const { message: messageApi } = App.useApp();
	// State to track the total amount
	// const [totalAmount, setTotalAmount] = useState(0);
	const [openModal, setOpenModal] = useState(false);
	const advanceAmountListSetForHistory = [...advanceAmountListSet]?.slice(0, -1);
	// State to track which values have been modified (for highlighting)
	const [modifiedFields, setModifiedFields] = useState({});
	// State to track row totals
	// const [rowTotals, setRowTotals] = useState([]);
	// State to control the Excel modal visibility
	const [excelModalVisible, setExcelModalVisible] = useState(false);
	// Use Form.useWatch to monitor the advanceAmount value directly from the form
	// const formAdvanceAmount = Form.useWatch(constantFormValues?.advanceAmount?.key, form);
	const handleHistory = () => {
		setOpenModal(true);
	};
	// Add this useEffect to debug form value changes
	// useEffect(() => {
	// 	console.log('Form advanceAmount changed:', formAdvanceAmount);
	// 	if (formAdvanceAmount !== undefined && formAdvanceAmount !== null) {
	// 		// If the form value exists but differs from our state, update our state
	// 		if (formAdvanceAmount !== totalAmount) {
	// 			console.log('Updating totalAmount state to match form:', formAdvanceAmount);
	// 			setTotalAmount(formAdvanceAmount);
	// 		}
	// 	}
	// }, [formAdvanceAmount]);

	// Add this useEffect to prevent the form from overriding our calculated total
	// useEffect(() => {
	// 	// When totalAmount changes, make sure the form value is updated
	// 	if (totalAmount > 0) {
	// 		const currentFormValue = form.getFieldValue(constantFormValues?.advanceAmount?.key);

	// 		// If the form value differs from our calculated total, update it
	// 		if (currentFormValue !== totalAmount) {
	// 			console.log('Updating form advanceAmount to match calculated total:', totalAmount);
	// 			form.setFieldValue(constantFormValues?.advanceAmount?.key, totalAmount);
	// 		}
	// 	}
	// }, [totalAmount]);
	function transformRangeDataToAmountArray(rangeData) {
		// Initialize an empty result array
		const result = [];

		// Process each range object
		rangeData.forEach((range) => {
			const fromValue = parseInt(range.from);
			const toValue = parseInt(range.to);

			// Skip invalid ranges
			if (isNaN(fromValue) || isNaN(toValue) || fromValue > toValue) {
				console.warn('Invalid range found:', range);
				return;
			}

			// Convert amount string to number (remove commas)
			const amount = parseFloat(String(range.amount).replace(/,/g, ''));

			// Skip if amount is not a valid number
			if (isNaN(amount)) {
				console.warn('Invalid amount found:', range);
				return;
			}

			// Calculate how many times to repeat the amount ((to - from) + 1)
			const repetitions = toValue - fromValue + 1;

			// Add the amount to the result array the specified number of times
			for (let i = 0; i < repetitions; i++) {
				result.push(amount);
			}
		});

		return result;
	}
	// useEffect(() => {
	// 	form.setFieldValue(constantFormValues?.advanceAmount?.key, totalAmount);
	// }, [totalAmount]);
	// Calculate row totals based on current form values
	// const calculateRowTotals = () => {
	// 	if (!form || !formListName) return;

	// 	try {
	// 		// Get the current values from the form
	// 		const values = form.getFieldValue(formListName);

	// 		if (values && Array.isArray(values)) {
	// 			const newRowTotals = values.map((item) => {
	// 				if (!item) return 0;

	// 				const fromValue = parseInt(item.from);
	// 				const toValue = parseInt(item.to);

	// 				// If amount exists, convert it from string to number
	// 				let amount = 0;
	// 				if (item.amount) {
	// 					const amountStr = String(item.amount).replace(/,/g, '');
	// 					amount = parseFloat(amountStr);
	// 				}

	// 				// Skip invalid values
	// 				if (isNaN(fromValue) || isNaN(toValue) || isNaN(amount) || toValue < fromValue) {
	// 					return 0;
	// 				}

	// 				// Calculate total: (to - from + 1) * amount
	// 				return (toValue - fromValue + 1) * amount;
	// 			});

	// 			setRowTotals(newRowTotals);
	// 		}
	// 	} catch (error) {
	// 		console.error('Error calculating row totals:', error);
	// 	}
	// };

	const calculateRowTotalsTwo = (index, advanceAmount) => {
		if (!form || !formListName) return;
		// console.log('calculateRowTotalsTwo');

		// const advanceAmount = form.getFieldValue(formListName);

		if (index === null) {
			// console.log('inside else');
			if (advanceAmount && Array.isArray(advanceAmount)) {
				// console.log(advanceAmount);
				advanceAmount.forEach((item, i) => {
					if (!item) return 0;

					const fromValue = parseInt(item.from);
					const toValue = parseInt(item.to);

					// If amount exists, convert it from string to number
					let amount = 0;
					if (item.amount) {
						const amountStr = String(item.amount).replace(/,/g, '');
						amount = parseFloat(amountStr);
					}

					// Skip invalid values
					if (isNaN(fromValue) || isNaN(toValue) || isNaN(amount) || toValue < fromValue) {
						return 0;
					}

					// Calculate total: (to - from + 1) * amount
					const total = (toValue - fromValue + 1) * amount;
					// console.log('total', total);
					form.setFieldValue([formListName, i, 'total'], total);
				});
			}
		} else {
			const advanceAmountRow = form.getFieldValue([formListName, index]);
			if (!advanceAmountRow) return 0;

			const fromValue = parseInt(advanceAmountRow.from);
			const toValue = parseInt(advanceAmountRow.to);

			// If amount exists, convert it from string to number
			let amount = 0;
			if (advanceAmountRow.amount) {
				const amountStr = String(advanceAmountRow.amount).replace(/,/g, '');
				amount = parseFloat(amountStr);
			}

			// Skip invalid values
			if (isNaN(fromValue) || isNaN(toValue) || isNaN(amount) || toValue < fromValue) {
				return 0;
			}

			// Calculate total: (to - from + 1) * amount
			const total = (toValue - fromValue + 1) * amount;

			form.setFieldValue([formListName, index, 'total'], total);
		}

		AdvancePaymentTotal();
	};

	const AdvancePaymentTotal = () => {
		const values = form.getFieldValue(formListName);

		if (values && Array.isArray(values)) {
			const grandTotal = values.reduce((sum, item) => {
				if (!item) return sum;

				const fromValue = parseInt(item.from);
				const toValue = parseInt(item.to);

				let amount = 0;
				if (item.amount) {
					const amountStr = String(item.amount).replace(/,/g, '');
					amount = parseFloat(amountStr);
				}

				if (isNaN(fromValue) || isNaN(toValue) || isNaN(amount) || toValue < fromValue) {
					return sum;
				}

				const total = (toValue - fromValue + 1) * amount;
				return sum + total;
			}, 0);

			// console.log('advanceAmount', grandTotal);
			form.setFieldValue('advanceAmount', grandTotal);
		}
	};

	// Calculate the total from all amount fields immediately when values change
	// Calculate the total from all amount fields immediately when values change
	// const calculateTotal = () => {
	// 	if (!form || !formListName) return;

	// 	try {
	// 		// First ensure row totals are calculated
	// 		calculateRowTotals();

	// 		// Now sum up the row totals instead of amounts
	// 		const sum = rowTotals.reduce((total, rowTotal) => total + (rowTotal || 0), 0);

	// 		// Update total amount state
	// 		setTotalAmount(sum);

	// 		// Still save the individual amounts to the main form for API submission

	// 		// if (values && Array.isArray(values)) {
	// 		// 	const { processedAdvanceAmounts } = processArrays(
	// 		// 		form.getFieldValue('grossRents'),
	// 		// 		values.map((item) => (item.amount ? parseFloat(String(item.amount).replace(/,/g, '')) : 0))
	// 		// 	);
	// 		// 	form.setFieldValue('advanceAmounts', processedAdvanceAmounts);
	// 		// }
	// 	} catch (error) {
	// 		console.error('Error calculating total:', error);
	// 	}
	// };

	// Handler for when an amount changes
	const handleAmountChange = (fieldName) => {
		// Mark this field as modified for highlighting
		setModifiedFields((prev) => ({
			...prev,
			[fieldName]: true,
		}));

		// Recalculate the total
		// setTimeout(calculateTotal, 10);
	};

	// Handler for "To" value changes
	const handleToChange = (fieldName) => {
		// Only mark this field as modified for highlighting
		setModifiedFields((prev) => ({
			...prev,
			[fieldName]: true,
		}));
		// Calculate row totals when "To" value changes
		// setTimeout(calculateRowTotals, 10);
	};

	// Validate To value ONLY on blur to allow typing multi-digit numbers
	const validateToValueOnBlur = (index) => {
		// Get the current values
		const currentValues = form.getFieldValue(formListName);
		if (!currentValues) return;

		const toValue = parseInt(currentValues[index].to);
		const fromValue = parseInt(currentValues[index].from);

		// Validate that To is greater than From
		if (!isNaN(toValue) && !isNaN(fromValue) && toValue < fromValue) {
			messageApi.error("'To' value must be greater than 'From' value");
			form.setFields([
				{
					name: [formListName, index, 'to'],
					value: '',
					errors: ["'To' value must be greater than 'From' value"],
				},
			]);
		}
		// Recalculate row totals after validation
		// calculateRowTotals();
	};

	// Validate if a row is complete and valid
	const isRowValid = (row) => {
		if (!row) return false;

		// Check if all required fields are filled
		const toValue = parseInt(row.to);
		const fromValue = parseInt(row.from);

		if (isNaN(toValue) || toValue <= 0) return false;
		if (isNaN(fromValue) || fromValue <= 0) return false;
		if (toValue < fromValue) return false;
		if (!row.amount) return false;

		return true;
	};

	// Handle adding a new row
	const handleAddRow = () => {
		const currentValues = form.getFieldValue(formListName);

		// Initialize with first row if no values
		if (!currentValues || !currentValues.length) {
			form.setFieldValue(formListName, [{ from: 1, to: '', amount: '' }]);
			return;
		}

		// Get the last row to validate
		const lastRow = currentValues[currentValues.length - 1];

		// Check if the last row is complete
		if (!isRowValid(lastRow)) {
			messageApi.error('Please complete all required fields in the current row before adding a new one');
			return;
		}

		// Get the "to" value from the last row
		const lastToValue = parseInt(lastRow.to);

		// New row's "From" value is last row's "To" value + 1
		const newFrom = lastToValue + 1;

		// Add the new row
		const newRow = { from: newFrom, to: '', amount: '' };
		form.setFieldValue(formListName, [...currentValues, newRow]);
	};

	// Handle the Excel data being applied from the Excel modal
	const handleExcelDataApplied = (data) => {
		// console.log('Applying Excel data to form:', data);

		// Update the form with the Excel data
		form.setFieldValue(formListName, data);

		// Recalculate total
		// setTimeout(calculateTotal, 10);

		// Mark all fields as modified
		const newModifiedFields = {};
		data.forEach((_, index) => {
			newModifiedFields[`${formListName}.${index}.to`] = true;
			newModifiedFields[`${formListName}.${index}.amount`] = true;
			// newModifiedFields[`${formListName}.${index}.remarks`] = true;
		});
		setModifiedFields(newModifiedFields);
		calculateRowTotalsTwo(null, data);

		// Show success message
		messageApi.success(`Successfully imported ${data.length} rows of data`);
	};
	// const leaseTermSetter = (value) => {
	// 	if (totalLeasePeriod < value) {
	// 		dispatch(setTotalLeasePeriod(+value));
	// 	}
	// };
	const debouncedUpdateForm = useCallback(
		debounce((value) => {
			// console.log('DEBOUNCED update to form:', value);
			form.setFieldValue(constantFormValues?.advanceAmount?.key, value);

			// Also update changes array if it exists
			const currentChanges = form.getFieldValue('changes');
			if (currentChanges && currentChanges.length > 0) {
				// Make a shallow copy to avoid direct state mutation
				const updatedChanges = [...currentChanges];
				updatedChanges[0] = {
					...updatedChanges[0],
					inputChangeAdvance: value,
				};
				form.setFieldValue('changes', updatedChanges);
			}
		}, 300),
		[form]
	);

	// Modify your handleApply function to use the debounced update
	const handleApply = () => {
		const currentValues = form.getFieldValue(formListName);
		if (!currentValues || currentValues.length === 0) return;

		const transformedData = transformRangeDataToAmountArray(currentValues);

		const grossRents = form.getFieldValue('grossRents');
		const { processedAdvanceAmounts, processedGrossRents } = processArrays(grossRents, transformedData);

		// const total = transformedData.reduce((sum, amount) => sum + amount, 0);
		// Set the advanceAmounts array for API submission
		form.setFieldValue('advanceAmounts', processedAdvanceAmounts);
		form.setFieldValue('grossRents', processedGrossRents);

		// Update state immediately
		const total = form.getFieldValue('advanceAmount');
		// setTotalAmount(total);

		// But debounce the form update
		debouncedUpdateForm(total);

		messageApi.success('Data applied successfully');

		// For debugging
		// console.log('After Apply - totalAmount state:', total);
	};

	// Initialize with the first row
	// useEffect(() => {
	// 	const currentValues = form.getFieldValue(formListName);
	// 	if (!currentValues || !currentValues.length) {
	// 		// Initialize with one row, from=1
	// 		form.setFieldValue(formListName, [{ from: 1, to: '', amount: '' }]);
	// 	}

	// 	// Calculate initial total if data exists
	// 	calculateTotal();
	// 	calculateRowTotals();
	// }, [formListName]);

	// Ensure advanceAmount in the form stays synchronized with the total
	// useEffect(() => {
	// 	// Only update the form when the total actually changes
	// 	if (totalAmount > 0) {
	// 		// form.setFieldValue(constantFormValues?.advanceAmount?.key, totalAmount);

	// 		// Also update changes array if it exists
	// 		const currentChanges = form.getFieldValue('changes');
	// 		if (currentChanges && currentChanges.length > 0) {
	// 			// Make a shallow copy to avoid direct state mutation
	// 			const updatedChanges = [...currentChanges];
	// 			updatedChanges[0] = {
	// 				...updatedChanges[0],
	// 				inputChangeAdvance: totalAmount,
	// 			};
	// 			form.setFieldValue('changes', updatedChanges);
	// 		}

	// 		console.log('Synchronized advanceAmount with total:', totalAmount);
	// 	}
	// }, [totalAmount]);

	return (
		<div>
			<>
				<Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
					<Col>
						<Button type="primary" onClick={handleAddRow} disabled={screen === 'VIEW'}>
							Add Row
						</Button>
					</Col>
					<Col>
						<Tooltip title="Import from Excel">
							<Button
								type="default"
								onClick={() => setExcelModalVisible(true)}
								disabled={screen === 'VIEW'}
								icon={<CloudUploadIcon style={{ fontSize: '16px' }} />}
								style={{ marginLeft: '8px' }}
							>
								Excel Import
							</Button>
						</Tooltip>
					</Col>
					{/* <Col>
								<InputLabel label={`Total: ${totalAmount.toLocaleString()}`} head={true} />
							</Col> */}
					<Col style={{ display: 'flex', flexDirection: 'row-reverse' }}>
						<Button type="primary" onClick={handleApply} disabled={screen === 'VIEW'}>
							Apply
						</Button>
					</Col>
					{advanceAmountListSetForHistory?.length !== 0 && (screen.toLowerCase() === 'view' || screen.toLowerCase() === 'edit') && (
						<Col>
							<Button type="primary" onClick={handleHistory}>
								History
							</Button>
						</Col>
					)}
				</Row>

				<TableContainer
					className="gross-rent-table"
					sx={{
						'& table, & th, & td': {
							border: '1px solid #e0e0e0',
							borderCollapse: 'collapse',
						},
						'& th, & td': {
							p: '5px',
						},
						'& td .ant-form-item': {
							marginBottom: '0px',
						},

						'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '20%' } /* From/From Month */,
						'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '20%' } /* To/To Month */,
						'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '20%' } /* Amount/Monthly Adjustment */,
						'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '20%' } /* Remarks/Total Amount */,
						'& th:nth-of-type(5), & td:nth-of-type(5)': { width: '20%' } /* Action */,
						'& table': { width: '100%' } /* Ensure table takes full container width */,
					}}
				>
					<Table aria-label="Gross Rent table">
						<TableHead>
							<TableRow>
								<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
								<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
								<TableCell sx={{ textAlign: 'center' }}>Monthly Adjustment</TableCell>
								<TableCell sx={{ textAlign: 'center' }}> Amount</TableCell>
								{/* <TableCell sx={{ textAlign: 'center' }}>Remarks</TableCell> */}
								<TableCell sx={{ textAlign: 'center' }}>Action</TableCell>
							</TableRow>
						</TableHead>

						<Form.List name={formListName}>
							{(fields, { remove }) => {
								return (
									<TableBody>
										{fields.length > 0 ? (
											fields.map((field, index) => (
												<TableRow key={field.key}>
													<TableCell>
														<Form.Item name={[field.name, 'from']}>
															<Input
																disabled={true} // Always disabled to prevent manual editing
																style={{
																	padding: '8px',
																	width: '100%',
																	backgroundColor: '#f5f5f5', // Grey background to indicate disabled
																	textAlign: 'center',
																}}
															/>
														</Form.Item>
													</TableCell>
													<TableCell>
														<Form.Item
															name={[field.name, 'to']}
															rules={[
																{ required: false, message: "Please enter a 'To' value" },
																({ getFieldValue }) => ({
																	validator(_, value) {
																		const fromValue = getFieldValue([formListName, field.name, 'from']);
																		if (!value || !fromValue) return Promise.resolve();
																		if (parseInt(value) <= parseInt(fromValue)) {
																			return Promise.reject(new Error("'To' must be greater than 'From'"));
																		}
																		return Promise.resolve();
																	},
																}),
															]}
														>
															<InputNumber
																disabled={screen === 'VIEW'}
																placeholder="Enter To value"
																style={{
																	padding: '3px 0',
																	width: '100%',
																	// borderColor: modifiedFields[`${formListName}.${field.name}.to`]
																	// 	? '#1890ff'
																	// 	: undefined,
																	textAlign: 'center',
																}}
																// onChange={() => handleToChange(`${formListName}.${field.name}.to`)}
																onBlur={() => {
																	handleToChange(`${formListName}.${field.name}.to`);
																	validateToValueOnBlur(index);
																}}
															/>
														</Form.Item>
													</TableCell>
													<TableCell>
														<Form.Item
															name={[field.name, 'amount']}
															rules={[{ required: false, message: 'Please enter an amount' }]}
															getValueFromEvent={(values) => {
																const data = +values.target.value.replace(',', '');

																return data ?? 0; // store as number, default to 0 if null
															}}
														>
															<NumericFormat
																size="small"
																decimalScale={2}
																placeholder="0.00"
																fixedDecimalScale
																thousandSeparator=","
																isAllowed={withValueCap}
																style={{
																	padding: '18px',
																	textAlign: 'right',
																	height: '32px',
																	borderRadius: '4px',
																	fontSize: '13px',
																	borderColor: modifiedFields[`${formListName}.${field.name}.amount`]
																		? '#1890ff'
																		: undefined,
																	backgroundColor: modifiedFields[`${formListName}.${field.name}.amount`]
																		? '#f0f7ff'
																		: undefined,
																}}
																customInput={Input}
																disabled={screen === 'VIEW'}
																// onValueChange={(values) => {
																// 	handleAmountChange(`${formListName}.${field.name}.amount`);
																// 	// First, get the current form values
																// 	const currentValues = [...form.getFieldValue(formListName)];

																// 	// Update the current field with the new value (or empty string if deleted)
																// 	if (currentValues[index]) {
																// 		// Update with the numeric value (not formatted)
																// 		currentValues[index].amount = values.value || '';

																// 		// Update the form with the new value
																// 		form.setFieldValue(formListName, currentValues);

																// 		// Calculate row total for this specific row
																// 		const fromValue = parseInt(currentValues[index].from);
																// 		const toValue = parseInt(currentValues[index].to);

																// 		// If amount is now empty, set row total to 0
																// 		if (!values.value) {
																// 			const newRowTotals = [...rowTotals];
																// 			newRowTotals[index] = 0;
																// 			setRowTotals(newRowTotals);

																// 			// Calculate new grand total from row totals
																// 			const newTotal = newRowTotals.reduce(
																// 				(total, rowTotal) => total + (rowTotal || 0),
																// 				0
																// 			);
																// 			setTotalAmount(newTotal);
																// 			return;
																// 		}

																// 		// Otherwise calculate normally
																// 		const amount = parseFloat(values.value);

																// 		if (
																// 			!isNaN(fromValue) &&
																// 			!isNaN(toValue) &&
																// 			!isNaN(amount) &&
																// 			toValue >= fromValue
																// 		) {
																// 			const newRowTotals = [...rowTotals];
																// 			newRowTotals[index] = (toValue - fromValue + 1) * amount;
																// 			setRowTotals(newRowTotals);

																// 			// Calculate new grand total from row totals
																// 			const newTotal = newRowTotals.reduce(
																// 				(total, rowTotal) => total + (rowTotal || 0),
																// 				0
																// 			);
																// 			setTotalAmount(newTotal);
																// 		}
																// 	}
																// }}
																// Add an onBlur handler to ensure calculation happens
																onBlur={() => {
																	// setTimeout(() => {
																	handleAmountChange(`${formListName}.${field.name}.amount`);
																	calculateRowTotalsTwo(index);
																	// 	calculateTotal();
																	// }, 10);
																}}
															/>
														</Form.Item>
													</TableCell>
													<TableCell style={{ textAlign: 'right', fontWeight: 'bold' }}>
														{/* <NumericFormat
															value={rowTotals[index] || 0}
															displayType="input"
															decimalScale={2}
															fixedDecimalScale
															thousandSeparator=","
															size="small"
															style={{
																padding: '18px',
																textAlign: 'right',
																height: '32px',
																borderRadius: '4px',
																fontSize: '13px',
																fontWeight: 'bold',
																backgroundColor: undefined,
																borderColor: undefined,
															}}
															customInput={Input}
															disabled={true}
															readOnly={true}
														/> */}
														<Form.Item name={[field.name, 'total']}>
															<NumericFormat
																size="small"
																decimalScale={2}
																placeholder="0.00"
																fixedDecimalScale
																thousandSeparator=","
																isAllowed={withValueCap}
																style={{
																	padding: '18px',
																	textAlign: 'right',
																	height: '32px',
																	borderRadius: '4px',
																	fontSize: '13px',
																	fontWeight: 'bold',
																	backgroundColor: undefined,
																	borderColor: undefined,
																}}
																customInput={Input}
																disabled={true}
															/>
														</Form.Item>
													</TableCell>
													{/* <TableCell> */}
													{/* <Form.Item name={[field.name, 'remarks']}>
														<Input
																placeholder="Enter remarks"
																disabled={screen === 'VIEW'}
																style={{
																	borderColor: modifiedFields[`${formListName}.${field.name}.remarks`]
																		? '#1890ff'
																		: undefined,
																}}
																onChange={() =>
																	setModifiedFields((prev) => ({
																		...prev,
																		[`${formListName}.${field.name}.remarks`]: true,
																	}))
																}
															/>
													</Form.Item> */}
													{/* </TableCell> */}
													<TableCell align="center">
														{screen !== 'VIEW' && index > 0 && (
															<Button
																danger
																type="primary"
																onClick={() => {
																	// const currentValues = [...form.getFieldValue(formListName)];

																	// // Update row totals array
																	// const newRowTotals = [...rowTotals];
																	// newRowTotals.splice(index, 1);
																	// setRowTotals(newRowTotals);

																	// // Remove the row
																	// currentValues.splice(index, 1);

																	// // Fix the From/To sequence if needed
																	// for (let i = index; i < currentValues.length; i++) {
																	// 	// If not the first row, From should be previous row's To + 1
																	// 	if (i > 0) {
																	// 		const prevTo = parseInt(currentValues[i - 1].to);
																	// 		if (!isNaN(prevTo)) {
																	// 			currentValues[i].from = prevTo + 1;
																	// 		}
																	// 	}
																	// }

																	// form.setFieldValue(formListName, currentValues);

																	// // Calculate new total from row totals
																	// const newTotal = newRowTotals.reduce(
																	// 	(total, rowTotal) => total + (rowTotal || 0),
																	// 	0
																	// );
																	// setTotalAmount(newTotal);
																	remove(index);
																	AdvancePaymentTotal();
																}}
															>
																Delete
															</Button>
														)}
													</TableCell>
												</TableRow>
											))
										) : (
											<TableRow>
												<TableCell colSpan={6} style={{ textAlign: 'center' }}>
													No data. Click "Add Row" to add new entries.
												</TableCell>
											</TableRow>
										)}
									</TableBody>
								);
							}}
						</Form.List>

						<TableFooter>
							<TableRow sx={{ height: 24 }}>
								<TableCell colSpan={2} align="right" style={{ fontWeight: 'bold' }}></TableCell>
								<TableCell colSpan={1} align="right" style={{ fontWeight: 'bold' }}>
									<InputLabel
										label={'Advance Payment'}
										head={true}
										sx={{
											justifyContent: 'end',
											marginBottom: '0px',
										}}
									/>
								</TableCell>
								<TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>
									<Form.Item name="advanceAmount">
										<NumericFormat
											displayType="input"
											decimalScale={2}
											fixedDecimalScale
											thousandSeparator=","
											size="small"
											style={{
												padding: '18px',
												textAlign: 'right',
												height: '32px',
												borderRadius: '4px',
												fontSize: '13px',
												fontWeight: 'bold',
												backgroundColor: undefined,
												borderColor: undefined,
											}}
											customInput={Input}
											disabled={true}
										/>
									</Form.Item>
									{/* {formatNumber(totalAmount)} */}
									{/* {formatNumber(form.getFieldValue(constantFormValues?.advanceAmount?.key))} */}
								</TableCell>

								<TableCell colSpan={2}></TableCell>
							</TableRow>
						</TableFooter>
					</Table>
				</TableContainer>

				{/* Hidden form field to store processed data for API submission */}
				<Form.Item name="advanceAmounts" noStyle />
				{/* <Form.Item name="advanceAmounts" hidden={true} /> */}
			</>

			{/* Excel import modal */}
			<GrossRentExcelModal
				visible={excelModalVisible}
				onCancel={() => setExcelModalVisible(false)}
				onApply={handleExcelDataApplied}
				existingData={form.getFieldValue(formListName) || []}
			/>
			<Modal
				title={'Advance Amount Modifications'}
				open={openModal}
				onCancel={() => setOpenModal(false)}
				width={800}
				footer={[
					<Button key="cancel" onClick={() => setOpenModal(false)}>
						Close
					</Button>,
				]}
			>
				{advanceAmountListSetForHistory?.map((item, index) => (
					<AdvanceAmountHistory key={index} data={item} index={index} />
				))}
			</Modal>
		</div>
	);
};

export default AdvanceAmount;